export default __webpack_public_path__ + "static/media/ghg-equation.a6137812.png";